<template>
  <el-input-number ref='input'
                   v-model='val'
                   :size='size'
                   :style='cssStyle'
                   :disabled='disabled'
                   :clearable='clearable'
                   :placeholder='placeholder'
                   @focus='$refs.input.select()'
                   @change="$emit('change', $event)"
                   :min="min"
                   :max="max"
                   :precision="precision"
                   :step="step"
                   :controls="controls">
  </el-input-number>
</template>

<script>
import CONST from "../../assets/js/constant";
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      default: "mini"
    },
    cssStyle: {
      default: "width: 100%"
    },
    clearable: {
      default: true
    },
    min: {
      default: 0
    },
    max: {
      default: CONST.DECIMAL.DEFAULT_MAX_NUM
    },
    precision: {
      default: CONST.DECIMAL.DEFAULT_PRECISION
    },
    step: {
      default: 1
    },
    placeholder: String,
    value: {
      default: ''
    },
    disabled: {
      default: false
    },
    controls: {
      default: false
    },
  },
  data() {
    return {
      val: this.value || ''
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxInputNumber.vue